import { ApolloError, ServerError } from "@apollo/client";
import { Css } from "~generated/css";

export function Error({ error }: { error: ApolloError | Error }) {
  return (
    <div css={Css.tac.mt4.wPx(600).mxa.$}>
      <img src="/images/error.jpg" css={Css.bshHover.my2.wPx(400).mxa.$} alt="" />
      {/* fixme Large text? */}
      <h1 css={Css.mb4.$}>&#x1F914; Something doesn't seem quite right here&hellip;</h1>
      <ErrorMessages error={error} />
    </div>
  );
}

function ErrorMessages({ error }: { error: ApolloError | Error }) {
  const errorMessages = getErrorMessages(error);

  return (
    <>
      {errorMessages && (
        <div css={Css.tal.wPx(460).mxa.$}>
          <p css={Css.mb1.$}>Errors</p>
          <pre css={Css.wsnw.bgGray100.p2.$}>
            <ul css={Css.m0.pl2.$}>
              {errorMessages.map((message, i) => (
                <li key={i}>{message}</li>
              ))}
            </ul>
          </pre>
        </div>
      )}
    </>
  );
}

export function getErrorMessages(error: ApolloError | Error): string[] | undefined {
  if (!isApolloError(error)) {
    return [error.message];
  }

  const networkError = error.networkError as ServerError;
  const errorResult = networkError?.result;

  if (!errorResult) {
    return [error.message];
  }

  // Remove duplicate error messages - It is possible the backend sent the same error message multiple times.
  const serverErrors: string[] | undefined = (errorResult as any).errors;

  return serverErrors
    ?.map((e: any) => e.message as string)
    .reduce((acc, m) => (acc.includes(m) ? acc : acc.concat(m)), [] as string[]);
}

function isApolloError(error: ApolloError | Error): error is ApolloError {
  return typeof error === "object" && "networkError" in error;
}
